<template>
  <section class="container">
    <div class="row grid-margin grid-align-center">
      <div class="col-xs-12">
        <v-heading :level="1"></v-heading>
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    name: 'v-empty'
  }
</script>
<style lang="scss" scoped>
</style>
